var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_c('div',{staticClass:"loading_bar",attrs:{"refs":"loadingBar"}},[_c('p',[_vm._v(_vm._s(_vm.minLeft)+" : "+_vm._s(_vm.secLeft))]),_c('div',{staticClass:"sliding_bar",style:({'width': _vm.sliderWidth})})])])}
var staticRenderFns = []

export { render, staticRenderFns }